<template>
  <div class="ok">
    <h5>
      <img src="@/assets/img/ok-logo.png" alt="">
      <span>Your Reliable Financial Partner</span>
    </h5>
    <div class="cont">
      <div class="left">
        <ul class="list">
          <li v-for="(item, ind) in list" :key="ind" @click="onClick(ind)" :class="{ active: ind === activeInd }">
            <img v-if="ind === activeInd" :src="item.icon1" alt="">
            <img v-else :src="item.icon" alt="">
            <span v-html="item.html"></span>
          </li>
        </ul>
        <img class="google_play" src="@/assets/img/google_play.png" alt="" @click="toOK">
      </div>
      <div class="right">
        <div class="prev" @click="prev">
          <img src="@/assets/img/prev.png" alt="">
        </div>
        <el-carousel
          ref="carousel"
          arrow="never"
          height="100%"
          class="my-swiper"
          trigger="click"
          indicator-position="none"
          @change="handleCurrentChange"
        >
          <el-carousel-item name="0" class="swiper-slide">
            <img src="@/assets/img/swiper1.png" alt="">
          </el-carousel-item>
          <el-carousel-item name="1" class="swiper-slide">
            <img src="@/assets/img/swiper2.png" alt="">
          </el-carousel-item>
          <el-carousel-item name="2" class="swiper-slide">
            <img src="@/assets/img/swiper3.png" alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="next" @click="next">
          <img src="@/assets/img/next.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeInd: 0,
      swiper: null,
      list: [
        {
          icon: require('@/assets/img/ok-icon1.png'),
          icon1: require('@/assets/img/ok-icon1-1.png'),
          html: 'Higher loan offer up to <b>₦1,000,000</b>'
        },
        {
          icon: require('@/assets/img/ok-icon2.png'),
          icon1: require('@/assets/img/ok-icon2-1.png'),
          html: '<b>No collateral</b> for loan application'
        },
        {
          icon: require('@/assets/img/ok-icon3.png'),
          icon1: require('@/assets/img/ok-icon3-1.png'),
          html: 'Loan tenures as long as <b>12 months</b>'
        }
      ]
    }
  },
  methods: {
    onClick(ind) {
      this.activeInd = ind
      this.$refs.carousel.setActiveItem(ind)
    },
    prev() {
      this.$refs.carousel.prev()
      this.activeInd = this.activeInd - 1
      if (this.activeInd < 0) {
        this.activeInd = 2
      }
    },
    next() {
      this.$refs.carousel.next()
      this.activeInd = this.activeInd + 1
      if (this.activeInd === 3) {
        this.activeInd = 0
      }
    },
    handleCurrentChange(ind) {
      this.activeInd = ind
    },
    toOK() {
      window.location.href = 'https://okash.onelink.me/rWwB/gi1tphhu'
    },
  },
}
</script>

<style>
.active b {
  color: #1D9D51;
}
</style>

<style lang="scss" scoped>
@import '@/styles/public.scss';

.ok {
  width: 100%;
  background-image: url('~@/assets/img/ok-bg.png');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 80px 120px 0;
  h5 {
    vertical-align: middle;
    img {
      width: 231px;
      margin-right: 24px;
      vertical-align: middle;
    }
    color: #210f60;
    font-size: 24px;
    font-weight: 500;
  }
}
.cont {
  @include flex-base;
}
.left {
  width: 630px;
  padding: 86px 0 68px;
  .list {
    li {
      height: 48px;
      margin-bottom: 86px;
      cursor: pointer;
      img {
        width: 48px;
        height: 48px;
        vertical-align: middle;
      }
      span {
        color: rgba(0, 0, 0, 0.85);
        font-size: 24px;
        font-weight: 500;
        margin-left: 24px;
        vertical-align: middle;
        b {
          font-size: 32px;
          font-weight: 600;
        }
      }
      &.active {
        span {
          color: #1D9D51;
        }
        b {
          color: #1D9D51;
        }
      }
    }
  }
  .google_play {
    width: 270px;
    height: 80px;
    cursor: pointer;
  }
}
.right {
  flex: 1;
  overflow: hidden;
  @include flex-center;
  .prev,
  .next {
    img {
      width: 46px;
      height: 46px;
    }
  }
}
.my-swiper {
  width: 410px;
  height: 640px;
  position: relative;
  overflow: hidden;
  transform: translate3d(0,0,0);
  margin: 0 20px;
  .swiper-slide{
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    transform: translate3d(0,0,0);
    img {
      width: 406px;
      height: 640px;
    }
  }
}

</style>